import React, { useState } from "react";
import { Col, DatePicker, Input, Modal, Row, Select } from "antd";
import { Option } from "antd/es/mentions";
import BaseButton from "../../Button/BaseButton";
import { useTranslation } from "react-i18next";
import InputText from "../../Input/InputText";
import "../../../../assets/style/modalStyle/addSurvey.scss";
import { useDispatch, useSelector } from "react-redux";

import EnterContent from "../../QuestionSurvey/EnterContent";
import {
  pupSelector,
  surveySelector,
} from "../../../../services/selector/index.";
import {
  addSurvey,
  setOpenModalAddSurvey,
  setOpenNotifySurvey,
} from "../../../../services/slice/SurveySlice";
import { IconEdit, IconUpLoad } from "../../../../assets/icon";
import LabelInput from "../../LabelInput";
import SelectValue from "../../Selector/SelectValue";
import ButtonSelectQuestion from "../../Button/ButtonSelectQuestion";
import StarRate from "../../QuestionSurvey/StarRate";
import EmotionRate from "../../QuestionSurvey/EmotionRate";
import moment from "moment";
import SelectAnswer from "../../QuestionSurvey/SelectAnswer";
import ModalSelectGroupCustomer from "../other/ModalSelectGroupCustomer";
import ModalDelete from "../delete/ModalDelete";
import { deleteGroupTime } from "../../../../services/slice/DealSlice";
import { setOpenPUDelete } from "../../../../services/slice/PopUpSlice";

const ModalAddSurvey = ({ title }) => {
  const [showSelectGroup, setShowSelectGroup] = useState(false);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const stateSuvery = useSelector(surveySelector);
  const [valueSelectUsed, setValueSelectUsed] = useState([]);
  const [valueSelectValid, setValueSelectValid] = useState([]);
  const [valueSelectExpired, setValueSelectExpired] = useState([]);
  const [valueSelectNumberMachine, setValueSelectNumberMachine] = useState([]);
  const statePup = useSelector(pupSelector);
  const { dataDelete } = statePup;
  const { isOpenModalAddSurvey } = stateSuvery;
  const [error, setError] = useState({
    isError: false,
    msg: "",
  });
  const [datapost, setDataPost] = useState({
    nameSurvey: "",
    typeSurvey: 1,
    timeStart: "",
    timeEnd: "",
    descriptions: "",
    typePreferential: 0,
    attractGroup: [],
    displayRange: 0,
    numberCustomer: 0,
    status: 1,
    listQuestions: [],
  });

  const [listQuestion, setListQuestion] = useState([]);
  const formatDate = "DD/MM/YYYY";

  // thêm mới khảo sát
  const handleSave = (status) => {
    if (datapost.attractGroup.length) {
      datapost.attractGroup = JSON.stringify(datapost.attractGroup);
    } else datapost.attractGroup = null;

    dispatch(
      addSurvey({
        ...datapost,
        status: status,
        listQuestions: listQuestion,
      })
    );
  };

  // đóng modal thêm khảo sát
  const handleCancel = () => {
    dispatch(setOpenModalAddSurvey(false));
  };
  //xóa câu hỏi khỏi cuộc khảo sát
  const handleDelete = (value) => {
    let arr = listQuestion.filter((item) => item.index !== value.index);
    arr = arr.map((item, indexId) => ({
      ...item,
      index: indexId + 1,
    }));
    setListQuestion(arr);
  };
  //sắp xếp vị trí câu hỏi trong cuộc khảo sát
  const handleSortDown = (value) => {
    let newData = [...listQuestion];
    const itemIndex = newData.findIndex((item) => item.index === value);
    if (itemIndex !== -1 && itemIndex < newData.length - 1) {
      [newData[itemIndex], newData[itemIndex + 1]] = [
        newData[itemIndex + 1],
        newData[itemIndex],
      ];
      newData = newData.map((item, index) => {
        return {
          ...item,
          index: index + 1,
        };
      });
      setListQuestion(newData);
    }
  };
  const handleSortUp = (value) => {
    let newData = [...listQuestion];
    const itemIndex = newData.findIndex((item) => item.index === value);
    if (itemIndex > 0) {
      [newData[itemIndex], newData[itemIndex - 1]] = [
        newData[itemIndex - 1],
        newData[itemIndex],
      ];
      newData = newData.map((item, index) => {
        return {
          ...item,
          index: index + 1,
        };
      });
      setListQuestion(newData);
    }
  };
  const handleDeleteGroupTime = () => {
    dispatch(deleteGroupTime(dataDelete.id));
    dispatch(
      setOpenPUDelete({
        stateOpen: false,
        content: "",
        id: "",
      })
    );
  };
  return (
    <>
      {/* {isOpenModalAddCategry ? <ModalAddCategory /> : null} */}
      {showSelectGroup ? (
        <ModalSelectGroupCustomer
          valueSelectExpired={valueSelectExpired}
          valueSelectNumberMachine={valueSelectNumberMachine}
          setValueSelectExpired={setValueSelectExpired}
          setValueSelectNumberMachine={setValueSelectNumberMachine}
          setValueSelectUsed={setValueSelectUsed}
          setValueSelectValid={setValueSelectValid}
          valueSelectUsed={valueSelectUsed}
          valueSelectValid={valueSelectValid}
          setDataPost={setDataPost}
          open={showSelectGroup}
          setOpen={setShowSelectGroup}
        />
      ) : null}
      {dataDelete.isOpenPUDelete ? (
        <ModalDelete
          handleDelete={handleDeleteGroupTime}
          textDisable="Bạn có đồng ý xóa nhóm"
          title="Xóa nhóm"
          width={680}
        />
      ) : null}
      <Modal
        maskClosable={false}
        className="wrapperModalAddSurvey"
        title={t(title)}
        centered
        width={1300}
        open={isOpenModalAddSurvey}
        onCancel={handleCancel}
        footer={[
          <BaseButton
            content={"Ghi lại"}
            typeBtn="btnOrange"
            handleClick={() => handleSave(1)}
            width={"174px"}
          />,
          <BaseButton
            content={"Đăng khảo sát"}
            typeBtn="btnOrange"
            icon={<IconUpLoad />}
            handleClick={() => handleSave(2)}
            width={"174px"}
          />,
        ]}
      >
        <Row>
          <Col span={3} style={{ display: "flex", alignItems: "center" }}>
            <LabelInput text={"Tên"} />
          </Col>
          <Col span={21}>
            <InputText
              focus
              text={datapost.name}
              setText={(value) =>
                setDataPost({ ...datapost, nameSurvey: value })
              }
              placeholder={"Nhập tên tiêu đề cho cuộc khảo sát"}
              maxLength={155}
              typeInput={`${
                !datapost.nameSurvey && error.isError
                  ? "checkEmptyText baseInput"
                  : "baseInput"
              }`}
            />
          </Col>
        </Row>
        <Row style={{ margin: "1.5rem 0" }}>
          <Col span={3} style={{ display: "flex", alignItems: "center" }}>
            <LabelInput text={"Mô tả"} />
          </Col>
          <Col span={21}>
            <InputText
              text={datapost.descriptions}
              setText={(value) =>
                setDataPost({ ...datapost, descriptions: value })
              }
              placeholder={"Nhập mô tả cho cuộc khảo sát"}
              maxLength={155}
              typeInput={`${
                !datapost.descriptions && error.isError
                  ? "checkEmptyText baseInput"
                  : "baseInput"
              }`}
            />
          </Col>
        </Row>
        <Row style={{ margin: "1.5rem 0" }}>
          <Col span={3} style={{ display: "flex", alignItems: "center" }}>
            <LabelInput text={"Loại khảo sát"} />
          </Col>
          <Col span={8}>
            <SelectValue
              defaultValue={"Tất cả"}
              width={229}
              type={"base"}
              handleChange={(value) =>
                setDataPost({ ...datapost, typeSurvey: value })
              }
              optionsValue={[
                { label: "Tất cả", value: 1 },
                { label: "Danh sách ccs", value: 2 },
              ]}
            />
          </Col>
          <>
            <Col span={4} style={{ display: "flex", alignItems: "center" }}>
              <LabelInput text={"Đối tượng hiển thị"} />
            </Col>
            <Col span={6}>
              <Select
                className="base"
                style={
                  error.msg === "Nhóm khách hàng nhận ưu đãi không xác định" &&
                  error.isError
                    ? { border: "1px solid red", width: "100%" }
                    : { width: "100%" }
                }
                onClick={() =>
                  datapost.typeSurvey === 2
                    ? dispatch(
                        setOpenNotifySurvey({
                          isOpen: true,
                          msg: "Bạn không thể thực hiện chức năng này khi chọn loại khảo sát Danh sách CCS",
                          type: "error",
                        })
                      )
                    : null
                }
                disabled={datapost.typeSurvey === 2 ? true : false}
                value={datapost.typePreferential}
                onChange={(value) => {
                  if (value === 0) {
                    // setValueSelectUsed([]);
                    // setValueSelectValid([]);
                    return setDataPost({
                      ...datapost,
                      attractGroup: [],
                      typePreferential: value,
                    });
                  }
                  setDataPost({ ...datapost, typePreferential: value });
                }}
              >
                <Option value={0}>
                  <span
                    style={{
                      width: "100%",
                      display: "flex",
                      overflow: "hidden",
                    }}
                    className="labelSelect"
                  >
                    Tất cả
                  </span>
                </Option>
                <Option value={1}>
                  <span
                    style={{
                      width: "100%",
                      display: "flex",
                      overflow: "hidden",
                    }}
                    className="labelSelect"
                    // onClick={() => setShowSelectGroup(true)}
                  >
                    KH thuộc đại lý
                  </span>
                </Option>
                <Option value={2}>
                  <span
                    style={{
                      width: "100%",
                      display: "flex",
                      overflow: "hidden",
                    }}
                    className="labelSelect"
                    // onClick={() => setShowSelectGroup(true)}
                  >
                    KH Online
                  </span>
                </Option>
              </Select>
            </Col>
          </>
        </Row>
        <Row style={{ margin: "1.5rem 0" }}>
          <Col span={3} style={{ display: "flex", alignItems: "center" }}>
            <LabelInput text={"Thời gian diễn ra từ"} />
          </Col>
          <Col span={8}>
            <DatePicker
              onClick={() =>
                datapost.typeSurvey === 2
                  ? dispatch(
                      setOpenNotifySurvey({
                        isOpen: true,
                        msg: "Bạn không thể thực hiện chức năng này khi chọn loại khảo sát Danh sách CCS",
                        type: "error",
                      })
                    )
                  : null
              }
              disabled={datapost.typeSurvey === 2 ? true : false}
              format={formatDate}
              style={{ width: "229px" }}
              onChange={(date) =>
                setDataPost({
                  ...datapost,
                  timeStart: moment(date).format("YYYY-MM-DD 00:00:00"),
                })
              }
              placeholder="Chọn thời gian"
            />
          </Col>

          <>
            <Col span={4} style={{ display: "flex", alignItems: "center" }}>
              <LabelInput text={"Phạm vi hiển thị"} />
            </Col>
            <Col span={6}>
              <Select
                onClick={() =>
                  datapost.typeSurvey === 2
                    ? dispatch(
                        setOpenNotifySurvey({
                          isOpen: true,
                          msg: "Bạn không thể thực hiện chức năng này khi chọn loại khảo sát Danh sách CCS",
                          type: "error",
                        })
                      )
                    : null
                }
                disabled={datapost.typeSurvey === 2 ? true : false}
                className="base"
                style={
                  error.msg === "Nhóm khách hàng nhận ưu đãi không xác định" &&
                  error.isError
                    ? { border: "1px solid red", width: "100%" }
                    : { width: "100%" }
                }
                defaultValue={0}
                value={datapost.displayRange}
                onChange={(value) => {
                  if (value === 0) {
                    // setValueSelectUsed([]);
                    // setValueSelectValid([]);
                    return setDataPost({
                      ...datapost,
                      attractGroup: [],
                      displayRange: value,
                    });
                  } else {
                    setShowSelectGroup(true);
                    setDataPost({ ...datapost, displayRange: value });
                  }
                }}
              >
                <Option value={0}>
                  <span
                    style={{
                      width: "100%",
                      display: "flex",
                      overflow: "hidden",
                    }}
                    className="labelSelect"
                  >
                    Toàn bộ KH
                  </span>
                </Option>
                <Option value={1}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      flexGrow: 1,
                      alignItems: "center",
                    }}
                  >
                    <span
                      style={{
                        width: "100%",
                        display: "flex",
                        overflow: "hidden",
                      }}
                      className="labelSelect"
                    >
                      Nhóm
                    </span>
                    <IconEdit onClick={() => setShowSelectGroup(true)} />
                  </div>
                </Option>
              </Select>
            </Col>
          </>
        </Row>
        <Row style={{ margin: "1.5rem 0", height: "58px" }}>
          <Col
            span={3}
            style={{ display: "flex", alignItems: "center", height: "34px" }}
          >
            <LabelInput text={"đến"} />
          </Col>
          <Col span={8}>
            <DatePicker
              onClick={() =>
                datapost.typeSurvey === 2
                  ? dispatch(
                      setOpenNotifySurvey({
                        isOpen: true,
                        msg: "Bạn không thể thực hiện chức năng này khi chọn loại khảo sát Danh sách CCS",
                        type: "error",
                      })
                    )
                  : null
              }
              disabled={datapost.typeSurvey === 2 ? true : false}
              format={formatDate}
              onChange={(date) =>
                setDataPost({
                  ...datapost,
                  timeEnd: moment(date).format("YYYY-MM-DD 23:59:59"),
                })
              }
              style={{ width: "229px" }}
              placeholder="Chọn thời gian"
            />
          </Col>

          <>
            <Col span={4} style={{ display: "flex", alignItems: "center" }}>
              <LabelInput text={"Số lượng"} />
            </Col>
            <Col span={6}>
              <InputText
                onClick={() =>
                  datapost.typeSurvey === 2
                    ? dispatch(
                        setOpenNotifySurvey({
                          isOpen: true,
                          msg: "Bạn không thể thực hiện chức năng này khi chọn loại khảo sát Danh sách CCS",
                          type: "error",
                        })
                      )
                    : null
                }
                disable={
                  datapost.typeSurvey === 2 || datapost.displayRange === 0
                    ? true
                    : false
                }
                width="100%"
                typeInput={`${
                  error.msg === "Bạn nhập sai định dạng. Vui lòng nhập lại"
                    ? "checkEmptyText baseInput"
                    : "baseInput"
                }`}
                text={datapost.numberCustomer}
                placeholder="Nhập số lượng KH nhận thông báo"
                setText={(value) =>
                  setDataPost({ ...datapost, numberCustomer: value })
                }
              />
            </Col>
            <Col span={14} />
            <Col span={8} style={{ marginTop: "1rem", fontSize: "11px" }}>
              <i className="note">
                (
                {t(
                  "Nếu không nhập số lượng thì thông báo sẽ gửi cho tất cả khách hàng trong nhóm"
                )}
                )
              </i>
            </Col>
          </>
        </Row>

        <Row style={{ margin: "1.5rem 0" }}>
          <Col span={3} style={{ display: "flex", alignItems: "center" }}>
            <LabelInput text={"Thêm câu hỏi"} />
          </Col>
          <Col span={20} className="wrapperButton">
            <ButtonSelectQuestion
              handleClick={() => {
                setListQuestion((pre) => [
                  ...pre,
                  {
                    index: pre.length + 1,
                    typeQuestion: 1,
                    nameQuestion: "",
                    required: 0,
                    listAnswer: [
                      {
                        index: 1,
                        content: "",
                        typeAnswers: 0,
                      },
                      {
                        index: 2,
                        content: "",
                        typeAnswers: 0,
                      },
                      {
                        index: 3,
                        content: "",
                        typeAnswers: 0,
                      },
                      {
                        index: 4,
                        content: "",
                        typeAnswers: 0,
                      },
                    ],
                  },
                ]);
              }}
              width={150}
              backgroundColor={"rgba(97, 181, 255, 0.8)"}
              content={"Radio(chọn 1)"}
            />
            <ButtonSelectQuestion
              width={200}
              handleClick={() => {
                setListQuestion((pre) => [
                  ...pre,
                  {
                    index: pre.length + 1,
                    typeQuestion: 2,
                    required: 0,
                    nameQuestion: "",
                    listAnswer: [
                      {
                        index: 1,
                        content: "",
                        typeAnswers: 0,
                      },
                      {
                        index: 2,
                        content: "",
                        typeAnswers: 0,
                      },
                      {
                        index: 3,
                        content: "",
                        typeAnswers: 0,
                      },
                      {
                        index: 4,
                        content: "",
                        typeAnswers: 0,
                      },
                    ],
                  },
                ]);
              }}
              backgroundColor={"rgba(84, 190, 0, 0.5)"}
              content={"Checkbox (Chọn nhiều)"}
            />
            <ButtonSelectQuestion
              handleClick={() => {
                setListQuestion((pre) => [
                  ...pre,
                  {
                    required: 0,
                    index: pre.length + 1,
                    typeQuestion: 3,
                    nameQuestion: "",
                  },
                ]);
              }}
              backgroundColor={"rgba(255, 185, 154, 1)"}
              content={"Xếp hạng"}
            />
            <ButtonSelectQuestion
              handleClick={() => {
                setListQuestion((pre) => [
                  ...pre,
                  {
                    index: pre.length + 1,
                    required: 0,
                    typeQuestion: 4,
                    nameQuestion: "",
                  },
                ]);
              }}
              backgroundColor={"rgba(255, 220, 97, 0.5)"}
              content={"Mức độ hài lòng"}
            />
            <ButtonSelectQuestion
              handleClick={() => {
                setListQuestion((pre) => [
                  ...pre,
                  {
                    index: pre.length + 1,
                    required: 0,
                    typeQuestion: 5,
                    nameQuestion: "",
                  },
                ]);
              }}
              backgroundColor={"rgba(249, 50, 87, 0.5)"}
              content={"Nhập nội dung"}
            />
          </Col>
        </Row>
        <Row style={{ marginTop: "1.5rem" }}>
          <Col span={3} style={{ display: "flex", alignItems: "center" }}></Col>
          <Col span={3}>
            <div className="hdQS">Thứ tự</div>
          </Col>
          <Col span={6}>
            <div className="hdQS">Câu hỏi</div>
          </Col>
          <Col span={7}>
            <div className="hdQS">Phương án</div>
          </Col>
          <Col span={2}>
            <div className="hdQS">Bắt buộc</div>
          </Col>
          <Col span={3}>
            <div className="hdQS">Chức năng</div>
          </Col>
        </Row>
        <div className="wrapperQuestions">
          {listQuestion.map((item) => {
            if (item.typeQuestion === 1) {
              return (
                <SelectAnswer
                  listQS={listQuestion}
                  setListQS={setListQuestion}
                  handleSave={handleSave}
                  handleSortUp={handleSortUp}
                  handleSortDown={handleSortDown}
                  handleDelete={handleDelete}
                  index={item.index}
                  typeAnswer={"radio"}
                />
              );
            }
            if (item.typeQuestion === 2) {
              return (
                <SelectAnswer
                  listQS={listQuestion}
                  setListQS={setListQuestion}
                  handleSave={handleSave}
                  handleSortUp={handleSortUp}
                  handleSortDown={handleSortDown}
                  handleDelete={handleDelete}
                  index={item.index}
                  typeAnswer={"checkBox"}
                />
              );
            }
            if (item.typeQuestion === 3) {
              return (
                <StarRate
                  listQS={listQuestion}
                  setListQS={setListQuestion}
                  handleSortUp={handleSortUp}
                  handleSortDown={handleSortDown}
                  handleDelete={handleDelete}
                  index={item.index}
                />
              );
            }
            if (item.typeQuestion === 4) {
              return (
                <EmotionRate
                  listQS={listQuestion}
                  setListQS={setListQuestion}
                  handleSortUp={handleSortUp}
                  handleSortDown={handleSortDown}
                  handleDelete={handleDelete}
                  index={item.index}
                />
              );
            }
            if (item.typeQuestion === 5) {
              return (
                <EnterContent
                  listQS={listQuestion}
                  setListQS={setListQuestion}
                  handleSortUp={handleSortUp}
                  handleSortDown={handleSortDown}
                  handleDelete={handleDelete}
                  index={item.index}
                />
              );
            }
          })}
        </div>
        <Row justify={"end"} style={{ position: "relative" }}>
          {/* </Col> */}
          {error.isError ? (
            <small className="msgError" style={{ bottom: -50, left: 220 }}>
              {t(error.msg)}
            </small>
          ) : null}
        </Row>
      </Modal>
    </>
  );
};

export default ModalAddSurvey;
